var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "linkdin__x2C__social__x2C_media_x2C__logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.478,16H77.522C43.718,16,16,43.721,16,77.521v356.957   C16,468.278,43.718,496,77.522,496h356.955C468.285,496,496,468.278,496,434.479V77.521C496,43.721,468.285,16,434.478,16z    M181,247.812V396h-65V258.868V209h65V247.812z M148.37,181.128c-18.083,0-32.756-14.662-32.756-32.756   c0-18.097,14.673-32.741,32.756-32.741c18.108,0,32.767,14.645,32.767,32.741C181.137,166.466,166.479,181.128,148.37,181.128z    M396,294v102h-56v-90.833c0-21.75-2.355-49.724-32.164-49.724c-30.262,0-34.836,23.679-34.836,48.156V396h-54V245.12V209h52v25   h0.554c7.756-14,26.757-25.02,55.051-25.02c47.672,0,63.872,22.543,68.305,57.812c1.052,8.277,1.458,17.208,1.458,27.208H396z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#1A1A1A"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.8497cf0d2b57b182a4f3516c11388770.svg";
export { ForwardRef as ReactComponent };